import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "ศูนย์แบ่งต่อ มูลนิธิกระจกเงา | ร่วมสร้างรอยยิ้มให้ผู้อื่น",
  description = "ร่วมบริจาคและสนับสนุนกิจกรรมการกุศล เพื่อสร้างโอกาสและความหวังให้กับผู้ที่ต้องการความช่วยเหลือ มูลนิธิกระจกเงา ศูนย์แบ่งต่อ",
  keywords = "มูลนิธิกระจกเงา, ศูนย์แบ่งต่อ, บริจาค, การกุศล, Mirror Foundation, Sharing Center, NGO Thailand, บริจาคเงิน, บริจาคสิ่งของ, กิจกรรมการกุศล",
  image = "https://mirror-foundation-bytony.com/logo.png",
  url = "https://mirror-foundation-bytony.com",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('ศูนย์แบ่งต่อ') ? title : `${title} | ศูนย์แบ่งต่อ มูลนิธิกระจกเงา`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="ศูนย์แบ่งต่อ มูลนิธิกระจกเงา" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
